<template>
  <div class="login-container">
    <div
      class="steps"
      :style="{
        borderBottom:
          (isButtonList && showStepSelectGame) || ewm
            ? 'none'
            : '2px solid #808080',
      }"
    >
      <!-- <div v-if="isButtonList && showStepSelectGame && !ewm" >
        请选择(Please Select){{ tokens }}
      </div> -->
      <div v-if="isButtonList && showStepUserLogin" class="chooseyw">登录</div>
      <el-steps
        :active="curActive"
        align-center
        v-if="!isButtonList && gameListIsNotEmpty"
      >
        <el-step :title="$t('jtLoginForm.STEP_SELECT_GAME')"></el-step>
        <el-step :title="$t('jtLoginForm.STEP_USER_LOGIN')"></el-step>
      </el-steps>
    </div>
    <div class="step-select-game step" v-if="showStepSelectGame">
      <div v-if="weihu" class="weihu">
        {{ weihu }}
      </div>
      <div v-if="ewm" class="ewm">
        <img :src="ewm" alt="" />
        <p>请用微信扫描或识别二维码登录</p>
      </div>
      <div v-else-if="gameListIsNotEmpty">
        <div v-if="isButtonList" class="buttonOut">
          <div class="buttonlist">
            <div
              v-for="(item, index) in gameList"
              :key="item.id"
              class="buttonlistli"
              @click="handelselect(index)"
            >
              <p
                :style="{
                  backgroundColor: isButtonNotBg
                    ? 'none'
                    : item['生效'] == 2
                    ? '#888'
                    : colors[index]
                }"
              >
                <!-- <i :class="icons[index]"></i> -->
                <img
                  :src="item['图标']"
                  :style="{ width: isButtonNotBg ? '100%' : '60%' }"
                />
              </p>
              <span v-html="item.label1 ? item.label1 : item.label"></span>
            </div>
          </div>
        </div>
        <div v-else>
          <el-radio-group v-model="curGameIdx" @change="radioChange">
            <el-radio
              v-for="(item, index) in gameList"
              :key="item.id"
              :label="index"
              :style="{ color: item.opening ? '#606266' : '#C0C4CC' }"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </div>
        <div class="btn-container" v-if="!isButtonList">
          <el-button type="primary" @click="nextStep">
            <span class="yahei">{{ buttontext }}</span>
          </el-button>
        </div>
      </div>
    </div>
    <div class="step-user-login step" v-if="showStepUserLogin">
      <div class="form-container">
        <div class="row">
          <div class="col-label">{{ $t('jtLoginForm.LABEL_GAME_NAME') }}</div>
          <div class="col-content gamename">{{ currentGame.label }}</div>
        </div>
        <div class="row" v-if="currentGame.expire !== '2099-12-31 23:59:59'">
          <div class="col-label">{{ $t('jtLoginForm.LABEL_EXPIRE_DATE') }}</div>
          <div class="col-content">{{ currentGame.expire }}</div>
        </div>
        <div class="row">
          <div class="col-label">{{ $t('jtLoginForm.LABEL_USERNAME') }}</div>
          <div class="col-content">
            <el-input
              v-if="isSelect"
              v-model="username"
              :placeholder="$t('jtLoginForm.LABEL_USERNAME_PLACEHOLDER')"
            ></el-input>
            <el-select
              v-model="username"
              filterable
              placeholder="请选择(Select)"
              v-else
            >
              <el-option
                v-for="item in options"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-label">{{ $t('jtLoginForm.LABEL_PASSWORD') }}</div>
          <div class="col-content">
            <el-input v-model="password" show-password></el-input>
          </div>
        </div>
      </div>
      <div class="btn-container">
        <el-button type="primary" @click="prevStep">
          <span class="yahei">{{ $t('jtLoginForm.BTN_PREV_STEP') }}</span>
        </el-button>
        <el-button
          type="primary"
          :disabled="loginBtnDisabled"
          @click="userLogin"
          :loading="loginloading"
        >
          <span class="yahei">{{ $t('jtLoginForm.BTN_LOGIN') }}</span>
        </el-button>
      </div>
      <div class="twolink">
        <div class="toforget">
          <router-link :to="forgetpassword" v-if="!currentGame['不需邮箱']">
            {{ $t('jtLoginForm.LABEL_FORGETPASSWORD') }}
          </router-link>
        </div>
        <div class="toregister" v-if="hasSignupUrl">
          <router-link :to="signupUrl">{{
            $t('jtLoginForm.LABEL_USER_SIGNUP')
          }}</router-link>
          <!-- <p>
            {{ $t('jtLoginForm.LABEL_USER_SIGNUP_TIPS') }}
          </p> -->
        </div>
      </div>
      <div class="footer-container">
        <div>
          <ol v-if="hasGameDescs">
            <li class="attention">{{ $t('jtLoginForm.CHECK_CAREFULLY') }}</li>
            <li v-for="(item, index) in currentGame.descriptions" :key="index">
              <a
                href="#"
                v-if="isModal(item)"
                @click.prevent="showGameDescContent(item)"
                >{{ index + 1 }}. {{ item.title }}</a
              >
              <a
                :href="item.contentOrUrl"
                v-if="isNewPage(item)"
                target="_blank"
                rel="noopener noreferrer"
                >{{ index + 1 }}. {{ item.title }}</a
              >
            </li>
          </ol>
        </div>
      </div>
    </div>
    <div>
      <el-dialog
        :title="dlgTitle"
        :visible.sync="dlgVisible"
        width="70%"
        :close-on-click-modal="false"
      >
        <div v-html="dlgContent"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { sha256 } from 'js-sha256'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'
import config from '@/config'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import locale from 'element-ui/lib/locale'

const STEP_SELECT_GAME = 0
const STEP_USER_LOGIN = 1

export default {
  name: 'jtLoginForm',
  props: {
    gameList: Array, // 外部传入的比赛列表
    loginloading: Boolean,
    isButtonList: Boolean, //是否按钮列表样式
    isButtonNotBg: Boolean, //按钮无背景
    weihu: String, //是否按钮列表样式
    curindex: Number,
    ewm: String,
  },
  data() {
    return {
      curActive: STEP_SELECT_GAME, // 当前step，第一步为0
      curGameIdx: 0, // 当前选中的比赛索引
      username: '', // 用户名
      password: '', // 密  码
      dlgTitle: '', // 对话框标题
      dlgContent: '', // 对话框内容
      dlgVisible: false, // 显示对话框
      // buttontext: $t('jtLoginForm.BTN_NEXT_STEP'),
      buttontext: '下一步(Next)',
      options: [],
      colors: [
        '#3f51b5',
        '#e91e63',
        '#ff9800',
        '#9c27b0',
        '#2196f3',
        '#00bcd4',
        '#cddc39',
        '#732929',
        '#ff5722',
        '#8bc34a',
        '#7363ed',
        '#ffeb3b',
        '#795548',
        '#359bcb',
        '#009688',
        '#673ab7',
        '#ffc107',
        '#03a9f4',
        '#8bc34a',
        '#e91e63'
      ],
      icons: ['el-icon-user-solid', 'el-icon-folder-add', 'el-icon-s-check'],
      tokens: storage.getItem('tokens')
    }
  },
  computed: {
    isSelect() {
      return this.options.length === 0
    },

    showStepSelectGame() {
      if (this.curindex != -1) {
        this.curActive = STEP_USER_LOGIN
        this.curGameIdx = this.curindex
        return false
      } else {
        return this.curActive === STEP_SELECT_GAME
      }
    },
    showStepUserLogin() {
      return this.curActive === STEP_USER_LOGIN
    },
    gameListIsNotEmpty() {
      return !(this.gameList == null || _.isEmpty(this.gameList))
    },
    currentGame() {
      return this.gameList[this.curGameIdx]
    },
    loginBtnDisabled() {
      return _.isEmpty(this.username) || _.isEmpty(this.password)
    },

    hasSignupUrl() {
      return this.currentGame.enableRegister
    },
    hasGameDescs() {
      return this.currentGame.descriptions !== undefined
    },

    signupUrl() {
      return `/signup.html?gameId=${this.currentGame.id}`
    },
    forgetpassword() {
      return `/forgetpassword.html?gameId=${this.currentGame.id}`
    },
  },

  methods: {
    nextStep() {
      let thisgame = this.gameList[this.curGameIdx]
      let url = thisgame['URL重定向']
      let code = thisgame['二维码']
      let opions = thisgame['选择模式']
      let sx = thisgame['生效'] == 2
      let cozeId = thisgame['COZE']
      if (sx) {
        this.$alert('服务未开通，敬请期待！', '提示', {
          confirmButtonText: '确定',
        })
      } else if (url) {
        window.open(url)
      } else if (code) {
        let mes = (
          <div>
            <img src={code} style={{ width: '100%', maxWidth: '400px' }} />
          </div>
        )
        this.$alert(mes, '微信扫描下方二维码', {
          customClass: 'code',
          confirmButtonText: '关闭',
          dangerouslyUseHTMLString: true,
        })
      } else {
        let languageConfig = thisgame['语言']
        storage.setItem(constants.LANGUAGE, languageConfig)
        if (languageConfig) {
          const lang = {
            中文: 'zh',
            英文: 'en',
            中英文: 'enAndzh',
            繁体中文: 'cn'
          }
          const language = languageConfig
          this.$i18n.locale = lang[language]
          this.$i18n.fallbackLocale = lang[language]
          if (languageConfig == '中文' || languageConfig == '中英文') {
            locale.use(zhLocale)
          } else if (languageConfig == '繁体中文') {
            locale.use(zhTWLocale)
          } else {
            locale.use(enLocale)
            document.body.style.fontFamily = 'Arial'
          }
        } else {
          this.$i18n.locale = process.env.VUE_APP_I18N_LOCALE || 'zh'
          this.$i18n.fallbackLocale = process.env.VUE_APP_I18N_LOCALE || 'zh'
        }
        if (!thisgame.opening) {
          let a = '该报名还未开通'
          let b = '，开通时间为：'
          let con = thisgame.openingData ? a + b + thisgame.openingData : a
          this.$alert(con, '提示', {
            confirmButtonText: '确定',
          })
        } else {
          if (opions) {
            this.options = opions
          } else {
            this.options = []
          }
          this.curActive = STEP_USER_LOGIN
          this.username = ''
          this.password = ''
        }
      }
      if (cozeId) {
        this.$root.COZEID = cozeId
        storage.setItem('COZEID', cozeId)
      }
    },
    prevStep() {
      this.$emit('resetindex')
      this.curActive = STEP_SELECT_GAME
      this.$root.COZEID = ''
      storage.clear('COZEID')
    },
    showGameDescContent(description) {
      this.dlgTitle = description.title
      this.dlgContent = description.contentOrUrl
      this.dlgVisible = true
    },
    userLogin() {
      try {
        const userInfo = this.validate()
        this.$emit('login', userInfo)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    validate() {
      const gameId = this.currentGame.id
      const username = this.username.trim()
      const password = sha256(this.password.trim() + config.appKey)

      return { gameId, username, password }
    },
    isModal(description) {
      return description.output === 1 // 1: modal
    },
    isNewPage(description) {
      return description.output === 2 // 2: newpage
    },
    radioChange(index) {
      let thisgame = this.gameList[index]
      let url = thisgame['URL重定向']
      let code = thisgame['二维码']
      if (url) {
        this.buttontext = '跳转登录（Jump login）'
      } else if (code) {
        this.buttontext = '打开二维码'
      } else {
        this.buttontext = '下一步(Next)'
      }
    },

    handelselect(index) {
      this.curGameIdx = index
      this.nextStep()
    },
  },
}
</script>

<style lang="stylus" scoped>
.steps {
  padding: 16px;
  border-bottom: 2px solid gray;
}

.chooseyw {
  width: 100%;
  text-align: center;
  font-size: 22px;
  font-weight: blod;
}

.step {
  min-height: 320px;
  padding: 8px;
  border-top: none;
}

.step-select-game >>> .el-radio-group {
  min-height: 280px;
  overflow: auto;
  display: flex;
  flex-direction: column;

  .el-radio {
    height: 32px;
    line-height: 32px;
    padding: 2px;
    white-space: normal;

    .el-radio__label {
      font-size: 16px;
    }
  }
}

.step-select-game >>> .btn-container {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .el-button {
    font-size: 16px;
    width: 50%;
  }
}

.weihu {
  font-size: 40px;
  text-align: center;
  margin-top: 80px;
}

.ewm {
  text-align: center;
  margin-top: 50px;

  img {
    margin-bottom: 10px;
    width: 160px;
  }
}

.step-user-login {
  .form-container {
    min-height: 200px;
    overflow: auto;
    display: flex;
    flex-direction: column;

    .row {
      // height: 32px;
      line-height: 24px;
      margin-bottom: 16px;
      display: flex;
      flex-direction: row;
      align-items: center;

      .col-label {
        min-width: 120px;
        text-align: left;
        padding-right: 10px;
        font-size: 18px;

        &:after {
          content: ': ';
        }
      }

      .col-content {
        width: 60%;
        font-size: 18px;
        font-font-weight: blod;
      }

      .col-content input {
        height: 32px;
        line-height: 32px;
      }

      .gamename {
        width: auto;
      }
    }
  }

  .btn-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 8px;

    .el-button {
      font-size: 16px;
      width: 40%;
    }
  }

  .footer-container {
    padding-top: 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    li {
      margin-top: 10px;

      a {
        color: #161ce6;
      }
    }

    .attention {
      font-weight: bold;
    }
  }
}

.twolink {
  display: flex;
  justify-content: space-between;
  margin: 20px;
}

.toforget {
  a {
    color: #161ce6;
  }
}

.toregister {
  text-align: right;

  a {
    color: #ff0000;
  }

  p {
    margin-top: 5px;
    color: #666;
    line-height: 22px;
  }
}

.code {
  width: '90%';
}

.buttonOut {
  display: flex;
  align-items: center;
  min-height: 300px;
  justify-content: center;
}

.buttonlist {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0px 0;
  justify-content: space-around;

  .buttonlistli {
    text-align: center;
    padding: 8px;
    cursor: pointer;
    width: 150px;
    transition: 0.25s ease-out;
    border-radius: 5px;

    &:hover {
      -webkit-transform: translateY(-10px);
      transform: translateY(-10px);
    }

    p {
      color: #fff;
      width: 80px;
      height: 80px;
      line-height: 73px;
      text-align: center;
      margin: 10px auto;
      font-size: 32px;
      border-radius: 50%;
    }

    span {
      display: inline-block;
      color: #000;
      text-align: center;
      line-height: 22px;
    }
  }
}

@media screen and (max-width: 768px) {
  .step-select-game >>> .el-radio-group {
    .el-radio {
      height: auto;
    }
  }

  .step-user-login {
    .form-container {
      .row {
        flex-wrap: wrap;
        margin-bottom: 5px;

        .col-label {
          text-align: left;
          font-size: 16px;
          width: 100%;
          // color: #505050;
        }

        .col-content {
          width: 100%;
          font-size: 16px;
        }
      }
    }
  }

  .buttonlist {
    .buttonlistli {
      width: 130px;

      p {
        width: 75px;
        height: 75px;
        line-height: 75px;
      }

      span {
        font-size: 14px;
      }
    }
  }
}
</style>
